import Icon from "@/components/base/Icon"
import { Stack, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"

export const ErrorMultipleFormatUploaded = () => {
    const { t } = useTranslation()
    return (
        <Stack gap={1} flexDirection={"row"} alignItems={"center"}>
            <Icon name="info" data-testid="info-icon" sx={{ color: "info.main" }} />
            <Typography variant="body2" color={"#014361"} fontFamily={"Poppins Medium"}>
                {t("SOCIALS.ERROR_MULTIPLE_FORMAT_UPLOADED")}
            </Typography>
        </Stack>
    )
}
